export const RichContentMigration = {
  CustomTab: 'specs.groups.CustomTabContentType',
  GroupDescription: 'specs.groups.GroupDescriptionContentType',
  GroupFeed: 'specs.groups.GroupFeedContentType',
  CentralFeed: 'specs.groups.CentralFeedContentType',
};

export type RichContentMigrationSpec = keyof typeof RichContentMigration;
